import React from "react";
import '../css/global.css';
import '../css/Creative.css';
import creativeSamples from '../images/creative-samples.webp';

const Creative: React.FC = () => {
    return(
        <section className="creative" id="creative">
            <div className="container">
               <div className="row justify-content-center">
                <div className="creative-col col-sm-5">
                <div className="header-content">
                    <span className="sub-heading">Creative Work</span>
                    <h3>Photography & Illustrations</h3>
                    <div className="section-divider">
                        <svg
                            width="80"
                            height="16"
                            viewBox="0 0 80 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M2 8 C8 2, 14 2, 20 8
                                S32 14, 38 8
                                S50 2, 56 8
                                S68 14, 78 8"
                                stroke="#B8E986"
                                strokeWidth="4"
                                strokeLinecap="round"
                                fill="none"
                            />
                        </svg>
                        <p>Explore my creative side through conceptual photography and digital illustrations.</p>
                        <div className="btn-group">
                            <a href="https://stephaniejeterstudios.com/" className="btn btn-primary primary-button-green" target="_blank" rel="noreferrer">
                                View Photography
                            </a>
                            <a href="https://stephaniejeterstudios.com/illustrations/" className="btn primary-button-purple" target="_blank" rel="noreferrer">
                                View Illustrations
                            </a>
                        </div>
                    </div>
                </div>
               </div>
                <div className="creative-col col-sm-5">
                     <img src={creativeSamples}
                        className="img-fluid"
                        alt="Preview of creative projects"
                    />
                </div>
              </div>
              </div>
            </section>
    ); }

    export default Creative;